export default [
    {
        title: 'Home',
        path: { path: '/', name: 'Welcome' },
        component: 'home',
        icon: 'home',
        inNav: false,

        meta: [
            { name: 'description', content: 'I am Gkiokan, a Fullstack Developer, spezialised in Back- and Frontend Development. I love to create Websites and PHP based Applications for any use case. Join my Network and profit from all of my SaaS and Enterprise Solutions.' },
            { name: 'keywords', content: 'Gkiokan, Network, Developer, Fullstack, SaaS, Projects, Development, Enterprise Developer, WordPress, PHP, Laravel, Vue, Love, YouTube, Netflix, KanaX, YTM, Youtube Manager, Videos, Movies, Series, Episodes, Gallery, Thumbnail Catcher' },
            { property: 'og:title', content: 'Welcome to Gkiokan.NET' },
            { property: 'og:site_name', content: 'Gkiokan.NET'},
            { property: 'og:description', content: 'I am Gkiokan, a Fullstack Developer, spezialised in Back- and Frontend Development. I love to create Websites and PHP based Applications for any use case. Join my Network and profit from all of my SaaS and Enterprise Solutions.' },
            { property: 'og:type', content: 'website'},
            { property: 'og:url', content: window.location.href },
            { property: 'og:image', content: 'https://gkiokan.net/modules/web/img/polygon_g_net_2.png' },

            { property: 'twitter:card', content: 'summary_large_image' },
            { property: 'twitter:url', content: window.location.href },
            { property: 'twitter:title', content: 'Welcome to Gkiokan.NET' },
            { property: 'twitter:description', content: 'I am Gkiokan, a Fullstack Developer, spezialised in Back- and Frontend Development. I love to create Websites and PHP based Applications for any use case. Join my Network and profit from all of my SaaS and Enterprise Solutions.' },
            { property: 'twitter:image', content: 'https://gkiokan.net/modules/web/img/polygon_g_net_2.png' },
        ]
    }, 

    {
        title: 'Test Env',
        path: { name: 'test' },
        component: 'test',
        inNav: false,
    }, 

    {
        title: 'Home',
        path: { name: 'home' },
        icon: 'home',
        inNav: true,
        meta: [
            { name: 'description', content: 'I am Gkiokan, a Fullstack Developer, spezialised in Back- and Frontend Development. I love to create Websites and PHP based Applications for any use case. Join my Network and profit from all of my SaaS and Enterprise Solutions.' },
            { name: 'keywords', content: 'Gkiokan, Network, Developer, Fullstack, SaaS, Projects, Development, Enterprise Developer, WordPress, PHP, Laravel, Vue, Love, YouTube, Netflix, KanaX, YTM, Youtube Manager, Videos, Movies, Series, Episodes, Gallery, Thumbnail Catcher' },
            { property: 'og:title', content: 'Welcome to Gkiokan.NET' },
            { property: 'og:site_name', content: 'Gkiokan.NET'},
            { property: 'og:description', content: 'I am Gkiokan, a Fullstack Developer, spezialised in Back- and Frontend Development. I love to create Websites and PHP based Applications for any use case. Join my Network and profit from all of my SaaS and Enterprise Solutions.' },
            { property: 'og:type', content: 'website'},
            { property: 'og:url', content: window.location.href },
            { property: 'og:image', content: 'https://gkiokan.net/modules/web/img/polygon_g_net_2.png' },

            { property: 'twitter:card', content: 'summary_large_image' },
            { property: 'twitter:url', content: window.location.href },
            { property: 'twitter:title', content: 'Welcome to Gkiokan.NET' },
            { property: 'twitter:description', content: 'I am Gkiokan, a Fullstack Developer, spezialised in Back- and Frontend Development. I love to create Websites and PHP based Applications for any use case. Join my Network and profit from all of my SaaS and Enterprise Solutions.' },
            { property: 'twitter:image', content: 'https://gkiokan.net/modules/web/img/polygon_g_net_2.png' },
        ]
    }, 

    // {
    //     title: 'Tools',
    //     path: { name: 'tools' },
    //     icon: 'fa fa-code',
    //     inNav: true,
    // },


    {
        title: 'About',
        path: { name: 'about' },
        icon: 'help_outline',
        inNav: true,
        meta: [
            { name: 'description', content: 'I am Gkiokan, a Fullstack Developer, spezialised in Back- and Frontend Development. I love to create Websites and PHP based Applications for any use case. Join my Network and profit from all of my SaaS and Enterprise Solutions.' },
            { property: 'og:title', content: 'About me and myself. Who I am?' },
            { property: 'og:site_name', content: 'Gkiokan.NET'},
            { property: 'og:description', content: 'Learn more about me, the founder and creator of Gkiokan.NET. Checkout my work life and my school history in the past. Nobody cares really about it but either way each one of us have a history that should been known and presented.' },
            { property: 'og:type', content: 'website'},
            { property: 'og:url', content: window.location.href },
            { property: 'og:image', content: 'https://gkiokan.net/modules/web/img/g_2018.jpeg' },

            { property: 'twitter:card', content: 'summary_large_image' },
            { property: 'twitter:url', content: window.location.href },
            { property: 'twitter:title', content: 'About me and myself. Who I am?' },
            { property: 'twitter:description', content: 'Learn more about me, the founder and creator of Gkiokan.NET. Checkout my work life and my school history in the past. Nobody cares really about it but either way each one of us have a history that should been known and presented.' },
            { property: 'twitter:image', content: 'https://gkiokan.net/modules/web/img/g_2018.jpeg' },
        ]
    }, 

    {
        title: 'Login',
        path: { path: '/auth/login', name: 'login' },
        icon: 'fingerprint',
        inNav: false,
    }, 

    {
        title: 'Data Privacy',
        path: { name: 'privacy' },
        icon: 'privacy_tip',
        inNav: false,
    }, 

    {
        title: 'Terms of Service',
        path: { name: 'tos', path: 'terms-of-service' },
        component: 'tos',
        icon: 'security',
        inNav: false,
    },

    {
        title: 'Kiosk',
        path: { name: 'kiosk' },
        inNav: false,
    }
]
